// extracted by mini-css-extract-plugin
export default {"freeform_angles_table":"FreeformAnglesTable_freeform_angles_table__xlDgo","accession_label":"FreeformAnglesTable_accession_label__OptqR"};